;(function () {
    angular
        .module('dashboard')
        .component('deliveryZones',
            {
                templateUrl: 'components/store/delivery-zones/delivery-zones.0491156b.html',
                bindings: {},
                controller: [
                    '$scope',
                    '$state',
                    '$uibModal',
                    'PermissionService',
                    'APIService',
                    'DashboardConfig',
                    'LocalisationService',
                    'ErrorService',
                    'notify',
                    "moment",
                    DeliveryZonesComponent]
            });

    function DeliveryZonesComponent(
        $scope,
        $state,
        $uibModal,
        PermissionService,
        APIService,
        DashboardConfig,
        LocalisationService,
        ErrorService,
        notify,
        moment
        ) {
        this.errorService = ErrorService;
        this.apiService = APIService;
        this.permissionService = PermissionService;
        this.config = DashboardConfig;
        this.uibModal = $uibModal;
        this.$state = $state;
        this.$scope = $scope;
        this.notify = notify;
        this.moment = moment;
        this.isLoading = false;

        this.dateTimeFormat = LocalisationService.Configuration.DateTimeFilterFormat;

        this.storeName = PermissionService.userContext.getCurrentContextName();
        this.storeId = PermissionService.userContext.StoreId;

        checkPermission(PermissionService);
        this.initialise();
    }

    function checkPermission(permissionService) {
        const hasPermission = permissionService
            .doesUserHavePermission(Dashboard.Models.Lookups.Permissions.ManageDeliveryZones);

        if (!hasPermission) {
            permissionService.navigateToAccessDenied();
        }
    }

    DeliveryZonesComponent.prototype = {
        initialise: function () {
            this.deliveryZones = [];
            this.apiService.DeliveryZones.getDeliveryZonesForStore(
                this.permissionService.userContext.StoreId)
                .then(result => {
                    this.deliveryZones = result.data;
                });
            this.alwaysDate = this.moment('2199-01-01');
            this.now = this.moment();
        },
        toggleZone: function(zone) {
            if(!zone.IsEnabled) {
                this.showDisableZonesModal(
                    this.uibModal,
                    [zone]);
            } else {
                zone.DisabledUntil = null;
            }
        },
        disableAll: function() {
            if(!this.hasZones()) {
                return;
            }

            this.showDisableZonesModal(
                this.uibModal,
                this.deliveryZones);
        },
        save: function() {
            if(!this.hasZones()) {
                return;
            }
            this.isLoading = true;

            this.apiService.DeliveryZones.setDeliveryZones(
                this.storeId,
                this.deliveryZones)
                .then(() =>  {
                this.notify.success("Delivery Zones saved successfully.");
                this.isLoading = false;
            })
                .catch((e) => {
                this.errorService
                    .showError("There was an issue saving delivery zones. Please try again", e);
                this.isLoading = false;
            })
        },
        hasZones: function() {
            return this.deliveryZones.length > 0;
        },
        showDisableZonesModal: function(modalController, zones) {
            if(!this.hasZones()) {
                return;
            }

            modalController.open({
                animation: true,
                templateUrl: 'components/store/delivery-zones/disable-delivery-zone-modal.0d553c0b.html',
                controller: 'DisableDeliveryZoneModalController',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    zones: () => {
                        return zones;
                    },
                }
            });
        },
    }
})();
